import React from 'react';

import { ArchivalCollection } from 'types';
import { ApiRoute, GridBodyType, PageKey, UrlRoute } from 'enums';
import { GridEntityConfig } from 'components/grid/grid-types';
import { Grid } from 'components/grid/grid';
import { archivalAidConfig } from 'modules/archival-aid/archival-aid-grid';

import { ArchivalCollectionDetail } from './archival-collection-detail';
import { ArchivalCollectionOrder } from './archival-collection-order';
import { ArchivalCollectionFavourite } from './archival-collection-favourite';
import { ArchivalCollectionQuote } from './archival-collection-quote';
import { ArchivalCollectionDownload } from './archival-collection-download';
import { archivalAidChildrenConfig } from 'modules/archival-aid/archival-aid-children/archival-aid-children-grid';
import { eadConfig } from 'modules/archival-aid/archival-aid-children/ead-grid-config';
import { actionButtonsFactory } from 'components/grid/right-panel/action-buttons-factory';

export const archivalCollectionConfig: GridEntityConfig<
  never,
  ArchivalCollection
> = {
  id: 'fondy',
  title: 'Fondy',
  getLabel: (item) => item?.name ?? '',
  getId: (item) => item.id,
  getChildrenFilter: (item) => ({
    field: 'archivalCollection.id',
    operation: 'EQ',
    value: item.id,
  }),
  params: {
    size: 500,
  },
  urlRoute: UrlRoute.ARCHIVAL_COLLECTION,
  apiRoute: ApiRoute.ARCHIVAL_COLLECTION,
  listApi: '/api/archival-collection/list',
  pageKey: PageKey.DETAIL_ARCHIVAL_COLLECTION,
  archivalAidLevel: 1,
  icon: 'work',
  ActionButtons: actionButtonsFactory([
    { id: 'favourite', Component: ArchivalCollectionFavourite },
    { id: 'download', Component: ArchivalCollectionDownload },
    { id: 'order', Component: ArchivalCollectionOrder },
    { id: 'quote', Component: ArchivalCollectionQuote },
  ]),
  bodyComponents: {
    [GridBodyType.DETAIL]: ArchivalCollectionDetail,
  },
};

export const archivalCollectionGridConfig: any[] = [
  archivalCollectionConfig,
  archivalAidConfig,
  archivalAidChildrenConfig,
  eadConfig,
];

export const ArchivalCollectionGrid = () => (
  <Grid gridConfig={archivalCollectionGridConfig} />
);
